import { useAppSelector } from "../../store/hooks";
import Image from "../Image";

export default function CustomLoader(props) {
  const { count } = useAppSelector((state) => state.loading);
  const { display } = props;

  const isLoading = Boolean(count || display);

  return (
    <div className="preloader" style={{ display: isLoading ? "flex" : "none" }}>
      <div className="content">
        <div className="loader-circle"></div>
        <div className="loader-line-mask">
          <div className="loader-line"></div>
        </div>
        <Image src={"/images/favicon_new.svg"} />
      </div>
    </div>
  );
}
